import React from 'react'
import ReactDOM from 'react-dom'

import wrapper from '../src/app/index'

const App = wrapper({})
const app = React.createElement(App, {}, null)
ReactDOM.render(app, document.getElementById('root'))
module?.hot?.accept()
